import { useState } from "react";
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { useEffect } from "react";
import { Facebook, Instagram, Youtube, GeoAltFill, EnvelopeAt } from 'react-bootstrap-icons';
import Reveal from "../component/Reveal";

const ContactUs = () => {
  useEffect(()=>{
    document.title = "JCI Lucena - Contact Us"
  }, [])
  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Subject: "",
    Message: "",
  });
  const [status, setStatus] = useState(""); // success or error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic frontend validation
    if (
      !formData.FirstName ||
      !formData.LastName ||
      !formData.Email ||
      !formData.Subject ||
      !formData.Message
    ) {
      setStatus("Please fill in all fields.");
      return;
    }

  try {
    // transfer formspree ID later on
    const response = await fetch("https://formspree.io/f/xbdebobd", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setStatus("Message sent successfully!");
      setFormData({
        FirstName: "",
        LastName: "",
        Email: "",
        Subject: "",
        Message: "",
      });
    } else {
      setStatus("Oops! Something went wrong.");
    }
    } catch (error) {
      setStatus("Error sending message. Try again later.");
    }
  };


  return (
    <Reveal>
      <div className="contact-us-page-div">
        <Container className='contact-us-container'>
          <Row>
            <Col>
              <div className="contact-us-paragraph">
                {/* <h1><b>Leave us a message</b></h1> */}
                <h1><b>Have Questions or ideas? Reach out and let's make a difference together.</b></h1>
                <h2>Send Us a Message</h2>
                <p>Have a question or suggestion? Fill out the form below and we’ll get back to you promptly!</p>
              </div>
              {/* <Form onSubmit={handleSubmit}> turn on when deploying */}
              <Form onSubmit={handleSubmit}>
                <div className="contact-us-form">
                  <Form.Label className="contact-us-form-label">First Name</Form.Label>
                  <InputGroup className="mb-3 contact-us-form-control">
                    <Form.Control
                      placeholder="Enter Your First Name"
                      name="FirstName"
                      value={formData.FirstName}
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <Form.Label className="contact-us-form-label">Last Name</Form.Label>
                  <InputGroup className="mb-3 contact-us-form-control">
                    <Form.Control
                      placeholder="Enter Your Last Name"
                      name="LastName"
                      value={formData.LastName}
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <Form.Label className="contact-us-form-label">Email</Form.Label>
                  <InputGroup className="mb-3 contact-us-form-control">
                    <Form.Control
                      type="email"
                      name="Email"
                      placeholder="Enter Your Email"
                      value={formData.Email}
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <Form.Label className="contact-us-form-label">Subject / Topic</Form.Label>
                  <InputGroup className="mb-3 contact-us-form-control">
                    <Form.Control
                      name="Subject"
                      value={formData.Subject}
                      onChange={handleChange}
                      placeholder="Enter Subject / Topic"
                    />
                  </InputGroup>

                  <Form.Label className="contact-us-form-label">Message</Form.Label>
                  <InputGroup className="contact-us-form-control">
                    <Form.Control
                      as="textarea"
                      name="Message"
                      value={formData.Message}
                      onChange={handleChange}
                      rows={6}
                      style={{ resize: "none" }}
                    />
                  </InputGroup>
                  <Button type="submit" variant="primary" className="mt-3">Send</Button>
                </div>
              </Form>
              <div className="contact-us-get-in-touch-div">
                <p className="contact-us-get-in-touch-paragraph">Whether you want to join our community of young leaders, learn about our programs, or collaborate on projects, we’re here to connect with you!</p>
              </div>
              <h1 className="contact-us-get-in-touch-header"><p>Get in Touch:</p></h1>
              <div className="contact-us-location">
                <GeoAltFill size={50} color='red'/>
                <p>Lucena City, Philippines</p>
              </div>
              <div className="contact-us-email">
                <EnvelopeAt size={50} color='black'/>
                <p>jcilucenajaycees@gmail.com</p>
              </div>
              <div className="contact-us-socials-buttons">
                <a href="https://www.facebook.com/jcilucenachapter" target="_blank" rel="noopener noreferrer">
                  <Button className="border-0 bg-transparent">
                    <Facebook size={50} color='blue'/>
                  </Button>
                </a>
                <a href="https://www.instagram.com/jcilucena" target="_blank" rel="noopener noreferrer">
                  <Button className="border-0 bg-transparent">
                    <svg width="0" height="0">
                      <defs>
                        <linearGradient id="instagramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#feda75" />
                          <stop offset="25%" stopColor="#fa7e1e" />
                          <stop offset="50%" stopColor="#d62976" />
                          <stop offset="75%" stopColor="#962fbf" />
                          <stop offset="100%" stopColor="#4f5bd5" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <Instagram size={50} style={{fill: 'url(#instagramGradient)'}}/>
                  </Button>
                </a>
                {/* <Button className="border-0 bg-transparent"><Youtube size={50} color='red'/></Button>  */}
              </div>
              <div className="contact-us-join-us-section">
                <h1><b>Join Us</b></h1>
                <h3>Are you 18 to 40 years old and ready to lead, rise, and rock on?</h3>
                <h3>Join JCI Lucena to:</h3>
                <ul>
                  <li>Develop leadership skills that make a real impact</li>
                  <li>Lead community projects that matter</li>
                  <li>Connect with like-minded, driven leaders</li>
                </ul>
                <p>Step up. Rise above. Rock on with us.</p>
                <Button href="https://forms.gle/ST1vKNfGtdwLHQ4v9" target="_blank" variant="primary">Become a member</Button>
              </div>
            </Col>
          </Row>
        </Container>
        {/* use Formspree to send email
            use free paln for now
        */}
      </div>
    </Reveal>
  )
}

export default ContactUs;